import {
  useGetTourQuery,
  useGetWorkspaceQuery,
  useLazyGetFolderQuery,
} from '@carboncopyco/data';
import { Breadcrumbs } from '@carboncopyco/ui';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTourPageProps } from './TourPageContext';

export const TourPageBreadcrumbs = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { organizationId, tourId } = useTourPageProps();
  const { data: workspace } = useGetWorkspaceQuery({
    organizationId: organizationId,
    id: workspaceId,
  });
  const { data: tour } = useGetTourQuery({
    organizationId,
    workspaceId,
    id: tourId,
  });
  const [getFolder, { data: folder }] = useLazyGetFolderQuery();

  const links = useMemo(
    () => [
      {
        label: workspace?.workspaceName,
        onClick: () => navigate(`/${organizationId}/workspace/${workspaceId}`),
      },
    ],
    [navigate, organizationId, workspace?.workspaceName, workspaceId]
  );

  useEffect(() => {
    if (tour?.folderId) {
      getFolder({
        organizationId,
        workspaceId,
        folderId: String(tour.folderId),
      });
    }
  }, [getFolder, organizationId, workspaceId, tour]);

  const getPageLinks = useMemo(() => {
    if (folder && tour.folderId) {
      return [
        ...links,
        {
          label: folder?.name,
          onClick: () =>
            navigate(
              `/${organizationId}/workspace/${workspaceId}/folder/${tour.folderId}`
            ),
        },
      ];
    }
    return links;
  }, [folder, links, navigate, organizationId, tour?.folderId, workspaceId]);

  return (
    <Breadcrumbs
      current={tour?.tourName}
      links={getPageLinks}
    />
  );
};
